import { Time } from 'lightweight-charts';
import { BzDateTime } from '@benzinga/date-utils';

const SECONDS_PER_MINUTE = 60;
export const EXPECTED_TIMEZONE = 'America/New_York';

export const getTimestampWithTimezoneOffset = (timestamp: number) => {
  const date = BzDateTime.from(timestamp);
  const timezoneOffset = -date.getTimezoneOffset() * SECONDS_PER_MINUTE;
  return Math.floor(date.getTime() / 1000) - timezoneOffset;
};

export const formatTime = (timestamp: number): Time => {
  return getTimestampWithTimezoneOffset(timestamp) as Time;
};
